import type { RouteRecordRaw } from 'vue-router';
import AccountList from '@/views/middleGround/member/accountList.vue';
import PhotoAlbum from '@/views/middleGround/member/photoAlbum.vue';
import SubCompanyList from '@/views/middleGround/member/subCompanyList.vue';
import PrototypeRoomList from '@/views/middleGround/member/prototypeRoomList.vue';
import MembershipFees from '@/views/middleGround/member/membershipFees.vue';
import TempletDetail from '@/views/middleGround/member/templetDetail.vue';
import BusinessList from '@/views/middleGround/member/businessList.vue';
import BeautyInBusiness from '@/views/middleGround/member/beautyInBusiness.vue';
import HandbagBusiness from '@/views/middleGround/member/handbagBusiness.vue';
import CompanyRole from '@/views/middleGround/member/companyRole.vue';
import Error from '@/views/error.vue';
import CompanyInfo from '@/views/middleGround/member/companyInfo.vue';
import OperateLog from '@/views/middleGround/member/operateLog.vue';

// 会员资料
export const MemberRoute: Array<RouteRecordRaw> = [
  {
    path: 'member/index',
    name: 'CompanyInfo',
    meta: {
      title: '会员资料-基本资料',
    },
    component: CompanyInfo,
  },
  {
    path: 'member/companyRole',
    name: 'CompanyRole',
    meta: {
      title: '会员资料-角色管理',
    },
    component: CompanyRole,
  },
  {
    path: 'member/accountList',
    name: 'AccountList',
    meta: {
      title: '会员资料-账号管理',
    },
    component: AccountList,
  },
  {
    path: 'member/subCompanyList',
    name: 'SubCompanyList',
    meta: {
      title: '企业资料-下属企业',
    },
    component: SubCompanyList,
  },
  {
    path: 'member/operateLog',
    name: 'OperateLog',
    meta: {
      title: '企业资料-操作日志',
    },
    component: OperateLog,
  },
  {
    path: 'member/membershipFees',
    name: 'MembershipFees',
    meta: {
      title: '企业资料-会员缴费',
    },
    component: MembershipFees,
  },
  {
    path: 'member/photoAlbum',
    name: 'PhotoAlbum',
    meta: {
      title: '企业图册-物业',
    },
    component: PhotoAlbum,
  },
  {
    path: 'member/prototypeRoomList',
    name: 'PrototypeRoomList',
    meta: {
      title: '样板间列表-社区商家',
    },
    component: PrototypeRoomList,
  },
  {
    path: 'member/templetDetail',
    name: 'TempletDetail',
    meta: {
      title: '样板间列表-样板间详情',
    },
    component: TempletDetail,
  },
  {
    path: 'member/businessList',
    name: 'BusinessList',
    meta: {
      title: '业务合作-业务列表',
    },
    component: BusinessList,
  },
  {
    path: 'member/beautyInBusiness',
    name: 'BeautyInBusiness',
    meta: {
      title: '业务合作-美居业务',
    },
    component: BeautyInBusiness,
  },
  {
    path: 'member/businessList/handbagBusiness',
    name: 'HandbagBusiness',
    meta: {
      title: '业务合作-拎包业务',
    },
    component: HandbagBusiness,
  },
  {
    path: 'member/error',
    name: 'Error',
    meta: {
      title: '未知页面',
    },
    component: Error,
  },
];

export default MemberRoute;
